import {useLocalStorage} from '@web-utilities/local-storage';
import {SHOW_FEEDBACK_CARD_STORAGE_KEY} from 'components/FeedbackCard/constants';

export function useSetShowFeedbackCardDate() {
  const [{value: showFeedbackDateValue, update: showFeedbackCardKey}] =
    useLocalStorage<string>(SHOW_FEEDBACK_CARD_STORAGE_KEY);
  const setShowFeedbackCardDate = () => {
    if (showFeedbackDateValue) return;

    showFeedbackCardKey(new Date().toISOString());
  };

  return setShowFeedbackCardDate;
}
